import type { BizStatusCode } from '@/config/biz-status'

export const zhCNMessages: Record<BizStatusCode, string> = {
  SUCCESS: '操作成功',
  AUTH_LOGIN_SUCCESS: '登录成功',
  AUTH_REGISTER_SUCCESS: '注册成功',
  AUTH_LOGOUT_SUCCESS: '已退出登录',
  AUTH_REFRESH_SUCCESS: '刷新成功',
  SMS_SEND_SUCCESS: '验证码已发送',
  NEWSFLASH_SYNC_SUCCESS: '同步完成',
  AUTH_TOKEN_MISSING: '请先登录',
  AUTH_TOKEN_INVALID: '登录凭证无效',
  AUTH_SESSION_EXPIRED: '登录已失效，请重新登录',
  AUTH_LOGIN_REQUIRED: '请先登录',
  AUTH_UNAUTHORIZED: '未授权访问',
  AUTH_REFRESH_INVALID: '登录凭证无效，请重新登录',
  AUTH_REFRESH_REUSED: '检测到异常登录，请重新登录',
  AUTH_REFRESH_EXPIRED: '登录已过期，请重新登录',
  AUTH_DEVICE_MISMATCH: '设备校验失败，请重新登录',
  AUTH_ENV_MISMATCH: '环境校验失败，请重新登录',
  AUTH_ACCOUNT_DISABLED: '账号已被禁用',
  AUTH_LOGIN_FAILED: '账号或密码错误',
  USER_NOT_FOUND: '用户不存在',
  USER_ALREADY_EXISTS: '该账号已注册',
  USER_ACCOUNT_INVALID: '请输入有效的手机号、邮箱或用户名',
  USER_ID_GENERATE_FAILED: '系统繁忙，请稍后重试',
  USER_PROFILE_UPDATED: '资料已更新',
  USER_PASSWORD_UPDATED: '密码已修改',
  AUTH_OLD_PASSWORD_WRONG: '原密码不正确',
  CAPTCHA_REQUIRED: '请填写图形验证码',
  CAPTCHA_INVALID: '图形验证码错误或已过期',
  SMS_DISABLED: '短信验证码暂未开放，请使用密码登录',
  SMS_COOLDOWN: '发送过于频繁，请稍后再试',
  SMS_CODE_INVALID: '验证码错误或已过期',
  NEWSFLASH_NOT_FOUND: '快讯不存在或尚未同步',
  NEWSFLASH_SYNC_FORBIDDEN: '无权执行同步',
  QUOTE_NOT_FOUND: '行情品种不存在',
  QUOTE_SYNC_FORBIDDEN: '无权执行行情同步',
  QUOTE_SYNC_SUCCESS: '行情同步完成',
  TRADE_NOT_AVAILABLE: '交易功能筹备中，敬请期待',
  FILE_TYPE_UNSUPPORTED: '不支持的文件类型',
  FILE_SIZE_EXCEEDED: '文件大小超出限制',
  VALIDATION_FAILED: '参数校验失败',
  RATE_LIMIT_EXCEEDED: '请求过于频繁，请稍后再试',
  OPERATION_TOO_FREQUENT: '操作过于频繁，请稍后再试',
  FORBIDDEN: '无权限访问',
  NOT_FOUND: '资源不存在',
  API_NOT_FOUND: '接口不存在',
  SERVER_ERROR: '服务器内部错误',
}
